import { Link } from "react-router-dom";

export default function GeneralSettings(props) {
  return (
    <form
      onSubmit={props.onSubmit}
      id="general-settings"
      className="bg-white rounded-3xl border mt-8 "
    >
      <div className="w-full mx-auto flex overflow-hidden rounded-b-none">
        <div className="w-1/3 border-r !pb-64 p-8 sm:p-12 hidden md:inline-block">
          <h2 className="font-medium text-xl mb-4 tracking-wide">
            General settings
          </h2>
          <p className="text-xs">Update your general settings</p>
        </div>
        <div className="md:w-2/3 w-full p-8 sm:p-12">
          <div className="pb-8">
            <label htmlFor="name" className="text-sm">
              What users see, when they visit your profile page
            </label>
            <div className="flex flex-col md:flex-row mt-4 md:mt-2 mb-16 md:mb-0">
              <div className="flex items-center mr-4">
                <input
                  id="inline-radio"
                  type="radio"
                  onChange={props.onChange}
                  checked={
                    props.settings.show_all_amas_on_profile_page === true
                  }
                  value={true}
                  name="show_all_amas_on_profile_page"
                  disabled={!props.amas.length}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  htmlFor="inline-radio"
                  className="ml-2 text-sm font-medium w-max"
                >
                  All AMAs
                </label>
              </div>
              <div className="flex flex-col xm:flex-row content-center mt-2 md:mt-0 w-full">
                <div className="flex items-center mr-4">
                  <input
                    id="inline-2-radio"
                    type="radio"
                    onChange={props.onChange}
                    checked={
                      props.settings.show_all_amas_on_profile_page === false
                    }
                    value={false}
                    name="show_all_amas_on_profile_page"
                    disabled={!props.amas.length}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="inline-2-radio"
                    className="ml-2 text-sm font-medium w-max"
                  >
                    Specific AMA
                  </label>
                </div>
                <select
                  id="amas"
                  onChange={props.onChange}
                  value={props.settings.profile_page_ama_uuid || ""}
                  name="profile_page_ama_uuid"
                  className="mt-2 xm:mt-0 border text-sm rounded-lg w-full p-2.5 truncate select"
                  disabled={!props.amas.length}
                >
                  {!props.amas.length ? (
                    <option>No AMAs yet</option>
                  ) : (
                    props.amas.map((ama, index) => (
                      <option
                        id={"ama-option-" + index}
                        key={ama.uuid}
                        value={ama.uuid}
                      >
                        {ama.title}
                      </option>
                    ))
                  )}
                </select>
                {!props.amas.length && (
                  <Link
                    to="/my-amas"
                    type="button"
                    state={{ create: true }}
                    className="text-blue-500 hover:text-blue-800 mt-2 xm:mt-0 xm:ml-4 self-center whitespace-nowrap"
                  >
                    Create AMA
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-8 sm:p-12 flex items-center flex-col mm:flex-row rounded-b-lg border-t">
        <p className="self-center text-xs text-center sm:text-left tracking-tight">
          Click on Save to update your General Settings
        </p>
        <button
          id="save-button"
          type="submit"
          form="general-settings"
          className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-12 w-full mm:w-fit py-3 mt-4 mm:mt-0 self-center mm:ml-auto rounded-full cursor-pointer relative flex items-center justify-center"
          disabled={props.isLoading}
        >
          {props.isLoading ? (
            <>
              <svg
                role="status"
                className="inline mr-3 w-4 h-4 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </form>
  );
}
